import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { mensajeErrorCarga } from '../../core/http-errors';
import { ErrorFichaComponent } from '../error-ficha/error-ficha.component';
import { Component } from "@angular/core";
import { Ejercicio, EjerciciosService, ResponseEjercicios } from "../../../api";
import { CoreComponent } from "../core/core.component";
import { ItemType } from "../formulario/request.model";
import { SpinnerComponent } from "../spinner/spinner.component";
import { elegirVigente } from "../../services/ejercicio-vigente.service";

@Component({
  selector: 'app-ejercicios',
  standalone: true,
  imports: [CoreComponent, SpinnerComponent, ErrorFichaComponent],
  templateUrl: './ejercicios.component.html',
  styleUrl: './ejercicios.component.scss'
})
export class EjerciciosComponent {

  type: ItemType = ItemType.EJERCICIOS;
  ejercicios: Ejercicio[] = [];
  titleForm = 'Crear ejercicio';
  mode: 'list' | 'Crear' | 'Editar' | 'showItem' = 'list';
  loading: boolean = true;

  error = '';

  constructor(
    private router: Router,
    private ejerciciosService: EjerciciosService,
  ) { }

  ngOnInit() {
    this.error = '';
    this.loading = true;
    this.ejerciciosService.ejerciciosGet().subscribe({
      next: (res: ResponseEjercicios) => {
        if (res.status?.status === 200) {
          this.ejercicios = res.ejercicios!;
          // Presentación: marca el ejercicio vigente (mismo criterio que el resto de Censo) sin hacer otra petición.
          const vigente = elegirVigente(this.ejercicios);
          this.ejercicios.forEach(e => { e['esVigente'] = vigente !== null && Number(e.id) === vigente.id; });
          this.loading = false;
        } else {
          this.error = mensajeErrorCarga(undefined, 'el listado de ejercicios');
          this.loading = false;
        }
      },
      error: (err: HttpErrorResponse) => {
        this.error = mensajeErrorCarga(err, 'el listado de ejercicios');
        this.loading = false;
      }
    });
  }

  irAInicio() {
    this.router.navigateByUrl('/home');
  }

}
